import { render, staticRenderFns } from "./ModalAgendamento.vue?vue&type=template&id=80fee956&scoped=true"
import script from "./ModalAgendamento.vue?vue&type=script&lang=ts"
export * from "./ModalAgendamento.vue?vue&type=script&lang=ts"
import style0 from "./ModalAgendamento.vue?vue&type=style&index=0&id=80fee956&prod&lang=css"
import style1 from "./ModalAgendamento.vue?vue&type=style&index=1&id=80fee956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fee956",
  null
  
)

export default component.exports